{
    "realm": "privat",
    "url": "http://localhost:8888/auth",
    "clientId": "sikkerInnsendingPublicClient"
}
